/* 
 * ZoomTransition.js
 * Created on 7-apr-2017
 * @author Swen Meeuwes for &ranj
 */

import ScreenNavigator from "../../ScreenNavigator";
import ZoomTransitionOptions from "./ZoomTransitionOptions";

export default class ZoomTransition {
    constructor(type) {
        this.type = type;
    }

    /**
     * @param {ScreenNavigator} screenNavigator 
     * @param {createjs.MovieClip} screen 
     * @param {ZoomTransitionOptions} animationOptions 
     */
    animate(screenNavigator, screen, animationOptions = new ZoomTransitionOptions()) {
        return new Promise(resolve => {
            const endState = { scale: animationOptions.endZoomScale };

            // Set the screen to its begin state if provided.
            if (animationOptions.startZoomScale !== undefined && animationOptions.startZoomScale !== null) {
                screen.set({ scale: animationOptions.startZoomScale });
            }

            if (animationOptions.startAlpha !== undefined && animationOptions.startAlpha !== null) {
                screen.set({ alpha: animationOptions.startAlpha });
            }

            if (animationOptions.endAlpha !== undefined && animationOptions.endAlpha !== null) {
                endState.alpha = animationOptions.endAlpha;
            }

            // Execute the tween with the given animation options
            createjs.Tween
                .get(screen)
                .wait(animationOptions.delay)
                .to(endState, animationOptions.duration, animationOptions.ease)
                .call(_ => {
                    // Handle callbacks in animation options
                    if (animationOptions.callbacks) {
                        for (var i = 0; i < animationOptions.callbacks.length; i++) {
                            animationOptions.callbacks[i].call(this);
                        }
                    }

                    resolve();
                });
        });
    }
}